import React from 'react';
import { Button, Card, DatePicker, Form, message, Spin, InputNumber, Input, Icon, Switch, Tooltip } from 'antd';
import CkInfoItem from "../../components/CkInfoItem";
import { fetchEvt } from "../../redux/actions/evt";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { inEditMode } from "../../redux/actions/global";
import { patchEventConfig, findEventCheckinCredit, updateEventCheckinCredita } from "../../services/evt";
import PurchaseServiceTips from "../PurchaseServiceTips";
import { isValidity } from "../../services/global";
import moment from 'moment';

const RangePicker = DatePicker.RangePicker;

const mapStateToPorps = state => {
    const loginedUser = state.loginedUser;
    const cmEnums = state.cmEnums;
    return { cmEnums, loginedUser };
};
const mapDispatchToProps = dispatch => ({
    fetchEvt: bindActionCreators(fetchEvt, dispatch),
});


class EvtViewCheckinCredit extends React.Component {
    constructor(props) {
        super(props);
        this.pstView = null;
        console.log(props)
        this.state = {
            validity: false,
            formLoading: false,
            creditData: {},

        }
    }
    componentDidMount() {
        this.fetchEventCheckinCredit()
        isValidity('SENIORMEMBER', (vaild) => {
            this.setState({
                validity: vaild
            })
        })

    }

    fetchEventCheckinCredit = () => {
        findEventCheckinCredit({ id: this.props.evt.header.id }).then(res => {
            if (res.code == 200) {
                this.setState({
                    creditData: res.data
                })
            } else {
                message.error(res.msg, 6);
            }
        }).catch(err => {
            message.warn("访问异常");
        })
    }

    intoEdit = () => {
        this.props.editableChange(this.props.editableStatePropName, true)
    }
    cancelEdit = () => {
        this.props.editableChange(this.props.editableStatePropName, false)
    }

    save = () => {
        this.props.form.validateFieldsAndScroll((error, values) => {
            if (!error) {
                this.changeFormLoading(true)
                console.log(values)
                if (values.enabledCheckinCredit) {
                    updateEventCheckinCredita(Object.assign({ id: this.props.evt.header.id }, values)).then(res => {
                        if (res.code == 200) {
                            this.fetchEventCheckinCredit()
                        } else {
                            message.error(res.msg, 6);
                        }
                    }).catch(err => {
                        message.warn("访问异常");
                    })
                }
                patchEventConfig(Object.assign({ id: this.props.evt.header.id }, values)).then(res => {
                    console.log("updateEventConfig res: ", res);
                    if (res.code == 200) {
                        message.info("更新成功!");
                        this.props.editableChange(this.props.editableStatePropName, false, true)
                    } else {
                        message.error(res.msg, 6);
                    }
                }).catch(err => {
                    message.warn("访问异常");
                }).finally(() => {
                    this.changeFormLoading(false)
                })
            } else {
                console.log('error', error, values);
            }
        });
    }

    changeFormLoading = (loading) => {
        this.setState({
            formLoading: loading
        })
    }

    render() {
        const evt = this.props.evt;
        const { creditData } = this.state;

        const { getFieldDecorator, getFieldValue, getFieldsValue, getFieldError, setFieldsValue } = this.props.form;

        const editableTools = this.props.editable ?
            <div className="evt-create-editable-tools">
                <Button type="primary" size="small" onClick={this.save}>保存</Button>
                <Button type="primary" size="small" ghost onClick={this.cancelEdit}>放弃</Button>
            </div>
            :
            <div className="evt-create-editable-tools" onClick={() => {
                this.state.validity ? this.intoEdit() : this.pstView.show()
            }}>
                <Button type="primary" size="small" ghost>编辑</Button>
            </div>

        return (
            <Form>
                <Spin spinning={this.state.formLoading}>
                    <Card bodyStyle={{ padding: "16px" }}>
                        {editableTools}
                        <CkInfoItem
                            label={<span>签到次数限制 &nbsp;

                                <Tooltip placement="bottom" overlayClassName='overlay-image'
                                    mouseEnterDelay={0.3} title={
                                        <div>
                                            同一参与人可重复签到总次数（0表示不限）
                                        </div>
                                    }>
                                    <Icon type="question-circle-o" />
                                </Tooltip>
                            </span>}
                        >
                            {
                                this.props.editable ?
                                    <div>
                                        {getFieldDecorator(`maxCheckinCount`, {
                                            initialValue: evt.config.maxCheckinCount,
                                            rules: [{ required: true, message: '必填项' }],
                                        })(
                                            <InputNumber
                                                style={{ width: 120 }}
                                                min={0}
                                                precision={0}
                                            />
                                        )}


                                    </div>
                                    :
                                    evt.config.maxCheckinCount == -1 ? "不限制" : `${evt.config.maxCheckinCount} 次`
                            }
                        </CkInfoItem>
                        <CkInfoItem
                            label={<span>签到积分设置 &nbsp;

                                <Tooltip placement="bottom" overlayClassName='overlay-image'
                                    mouseEnterDelay={0.3} title={
                                        <div>
                                            参与人签到成功后可得指定积分 <a href="https://www.kancloud.cn/seven_qdj/qdj_detail01/1854809" target="_Blank" >  详细帮助</a>
                                        </div>
                                    }>
                                    <Icon type="question-circle-o" />
                                </Tooltip>
                            </span>}
                        >
                            {
                                this.props.editable ?
                                    <div>
                                        <div style={{ width: '50%' }}>
                                            {getFieldDecorator(`enabledCheckinCredit`, {
                                                initialValue: evt.config.enabledCheckinCredit,
                                                valuePropName: 'checked',
                                                rules: [{ required: false }],
                                            })(
                                                <Switch checkedChildren={"开启"} unCheckedChildren={"关闭"} />
                                            )}
                                        </div>


                                    </div>
                                    :
                                    evt.config.enabledCheckinCredit ? "已设置" : "未设置"
                            }
                        </CkInfoItem>
                        {
                            this.props.editable &&
                            <div>
                                <CkInfoItem
                                    label={'签到次数'}
                                >
                                    {getFieldDecorator(`checkinCount`, {
                                        initialValue: creditData.checkinCount ? creditData.checkinCount : 1,
                                        rules: [{ required: true, message: '必填项' }],
                                    })(
                                        <InputNumber
                                            style={{ width: 120 }}
                                            min={1}
                                            precision={0}
                                        />
                                    )}
                                </CkInfoItem>
                                <CkInfoItem
                                    label={'签到得分'}
                                >
                                    {getFieldDecorator(`checkinCredit`, {
                                        initialValue: creditData.checkinCredit ? creditData.checkinCredit : 1,
                                        rules: [{ required: true, message: '必填项' }],
                                    })(
                                        <InputNumber
                                            style={{ width: 120 }}
                                            min={1}
                                            precision={0}
                                        />
                                    )}
                                </CkInfoItem>
                            </div>
                        }



                    </Card>
                </Spin>
                <PurchaseServiceTips
                    ref={(pst) => {
                        this.pstView = pst
                    }}
                    member={'SENIORMEMBER'}
                />
            </Form>
        )
    }
}


EvtViewCheckinCredit.contextTypes = {}

EvtViewCheckinCredit.defaultProps = {
    evt: {},
    editable: false,
    editableStatePropName: "checkinCredit",
    editableChange: (editable, dataChanged = false) => null,
}

EvtViewCheckinCredit.propTypes = {}


export default connect(mapStateToPorps, mapDispatchToProps)(Form.create()(EvtViewCheckinCredit));


// WEBPACK FOOTER //
// ./src/containers/evt/EvtViewCheckinCredit.jsx